import _ from "lodash";
import React from "react";
import Reflux from "reflux";
import Linkify from "react-linkify";
import moment from "moment";
import logger from "../../utils/LoggerFrontend";
import Actions from "../../Actions";
import StatusStore from "../../Stores/StatusStore";
import UploadPhotoBtn from "../../Components/UploadPhotoBtn.jsx";

import {
  prepareImageFolderName,
  isCampaignManagerAvailable,
  getNextAvailableCampaignManagers,
  getCMwithMostComments
} from "../../utils/Helpers";

// eslint-disable-next-line import/no-unresolved
import { Store__System, CustomerSucessController } from "@talentbait/shared-components";
import { withTranslation } from "react-i18next";
const classNames = require("classnames");

class CampaignReadSideBar extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingComments: false,
      value: "",
      campaignManagerData: {}
    };

    this.stores = [Store__System, StatusStore];

    logger.debug(
      "CampaignSidebar:constructor",
      "called...",
      this.props.orgaId,
      this.props.campaignId
    );

    // Start loading the comments of this campaign
    Actions.fetchAllComments(this.props.orgaId, this.props.campaignId);

    // Comments did load successfully
    this.loadHandler = Actions.fetchAllComments.completed.listen(() => {
      logger.debug("CampaignSidebar:fetchAllComments:completed", "called...");
      this.setState({
        isLoadingComments: false
      });
    });

    // Comments didn"t load succesfully
    this.loadHandlerFailed = Actions.fetchAllComments.failed.listen((err) => {
      logger.debug("error:CampaignSidebar:fetchAllComments:failed", "called...", err);
      this.setState({
        isLoadingComments: false
      });
    });
    Actions.getAllCampaignManagers();
  }

  componentWillUnmount() {
    // Remove listenes
    this.loadHandler();
    this.loadHandlerFailed();
  }

  componentWillUpdate(nextProps, nextState) {
    // We need this if-statement, in case the view wasn"t destroy and rather
    // resused.
    if (this.props.campaignId !== nextProps.campaignId && !this.state.isLoadingComments) {
      logger.debug("CampaignSidebar:componentWillUpdate", "Fetch again!!!!");

      this.setState({
        isLoadingComments: true
      });

      Actions.fetchAllComments(nextProps.orgaId, nextProps.campaignId);
    }
    if (
      !_.isEqual(this.state.campaignManagers, nextState.campaignManagers) ||
      !_.isEqual(this.state.campaignComments, nextState.campaignComments)
    ) {
      const campaignManagerData = this.getCampaignManagerToShow(
        this.props.campaignManager,
        nextState.campaignManagers,
        nextState.campaignComments
      );
      this.setState({ campaignManagerData });
    }
  }

  renderImages() {
    return _.map(this.props.images, function (src) {
      return (
        <div className="campaign-read__photo">
          {" "}
          <img src={src} />{" "}
        </div>
      );
    });
  }

  renderLocations(locs) {
    return _.map(locs, (city, index) => {
      return (
        <span key={index}>
          • {city} <br />
        </span>
      );
    });
  }

  renderDate() {
    if (this.props.activeDate === "now") {
      return <span> {moment(this.props.createdDate).format("DD.MM.YYYY")} (Sofort)</span>;
    }
    return <span> {moment(this.props.startDate).format("DD.MM.YYYY")} (Später)</span>;
  }

  onChange(e) {
    this.setState({
      value: e.target.value || ""
    });
  }

  saveComment(campaignManager, e) {
    logger.log("CampaignSidebar:saveComment", "save comment called", {
      rank: this.props.superRank,
      campaignManager
    });

    if (!this.state.value || this.state.value === "" || this.state.value === " ") {
      logger.log("error:CampaignSidebar:saveComment", "no values passed in");
      return;
    }

    const { campaignId, orgaId, userName, userRole, userId } = this.props;

    Actions.storeComment(
      orgaId,
      campaignId,
      this.state.value,
      userName,
      userRole || "enduser",
      userId,
      {
        initiator: "user",
        type: "comment",
        eventName: "comment",
        eventStatus: "posted",
        assignedCampaignManager: campaignManager?.frontUserId || ""
      }
    );

    if (this.props.superRank !== "admin") {
      Actions.changeCampaignData(orgaId, campaignId, "requiresAttention", true);
      Actions.changeCampaignData(orgaId, campaignId, "lastStatus", this.props.status);
    }

    CustomerSucessController.send("CampaignRead:addedComment", {
      campaignId: campaignId,
      comment: this.state.value
    });

    this.setState({
      value: ""
    });
  }

  deleteComment(commentId, e) {
    e.preventDefault();

    if (!commentId) {
      return logger.log("error:CampaignSidebar:deleteComment", "No commentId passed in");
    }

    const ref = Actions.deleteComment.completed.listen(() => {
      Actions.addNotification("Kommentar gelöscht");
      logger.log("CampaignSidebar:deleteComment", "comment was deleted...", commentId);
      ref();
    });

    const refErr = Actions.deleteComment.failed.listen(() => {
      Actions.addNotification("Kommentar konnte nicht gelöscht werden", "error");
      logger.log("error:CampaignSidebar:deleteComment", "comment wasnt deleted...", commentId);
      refErr();
    });

    Actions.deleteComment(this.props.orgaId, this.props.campaignId, commentId);
  }
  renderDelete(userId, commentUserId, commentId) {
    const { t } = this.props;

    if (userId && commentUserId && commentUserId === userId) {
      return (
        <a
          href="#"
          onClick={this.deleteComment.bind(this, commentId)}
          className="button--float button--destructive transition"
        >
          {t("Delete")}
        </a>
      );
    }
  }
  renderLineBreaks(text) {
    return (text || "").split("\n").map((item, index) => {
      return (
        <span key={`${item}-${index}`}>
          {item} <br />
        </span>
      );
    });
  }
  renderComments() {
    const { t } = this.props;
    if (!this.state.campaignComments) {
      return <div className="comments__fallback-msg">{t("No comments")}</div>;
    }

    const comments = _.sortBy(this.state.campaignComments, function (num) {
      return -num.createDate;
    });

    return comments.map((comment, key) => {
      const styleComment = classNames({
        comments__comment: true,
        "comments__comment--admin": comment.userrole && comment.userrole === "helpdesk"
      });

      return (
        <div className={styleComment} key={key}>
          <strong className="comments__comment-author">{comment.userName}</strong>
          <span
            className="comments__comment-date"
            title={moment(comment.createDate).format("DD.MM.YY")}
          >
            {moment(comment.createDate).fromNow()}
          </span>
          <span className="comments__comment-content">
            <Linkify properties={{ target: "_blank" }}>
              {this.renderLineBreaks(comment.comment)}
            </Linkify>
            {comment.meta &&
              comment.meta.url &&
              new RegExp([".jpg", ".png", ".jpeg"].join("|")).test(comment.meta.url) && (
                <span>
                  <a target="_blank" href={comment.meta.url} rel="noreferrer">
                    <img src={comment.meta.url} alt="" />
                  </a>
                </span>
              )}

            {comment.meta &&
              comment.meta.type == "file-upload" &&
              comment.meta.url &&
              comment.meta.url.includes("mp4") && (
                <span>
                  <video src={comment.meta.url} style={{ width: "100%" }} controls>
                    <source src={comment.meta.url} type="video/mp4" />
                    <track kind="captions" label="Captions" />
                    {t("Sorry, your browser doesn't support embedded videos")}
                  </video>
                </span>
              )}
          </span>
          {this.renderDelete(this.props.userId, comment.userId, comment.id)}
        </div>
      );
    });
  }
  handleScroll(e) {
    e.stopPropagation();
  }
  handleKeyPress(e) {}
  handlePictureChanged(data) {
    const { t } = this.props;

    const { userProfile } = this.state;

    const { campaignId, orgaId, userRole, userId, campaignManager } = this.props;

    const comment =
      `${userProfile && userProfile.userName} ${t("has uploaded a file")}: 📥 ` + data.url;
    const userName = userProfile && userProfile.userName;
    const userrole = "admin";

    logger.log("CampaignSidebar:handlePictureChanged", "called...", {
      data,
      userId
    });

    const ref = Actions.storeComment.completed.listen((comment) => {
      Actions.addNotification(t("The file was uploaded successfully."));
      ref();
    });

    Actions.storeComment(orgaId, campaignId, comment, userName, userrole, userId, {
      url: data.url,
      userName,
      initiator: "user",
      type: "file-upload"
    });
  }

  getCampaignManagerToShow(frontUserId, campaignManagers, comments) {
    const selectedCM = _.filter(campaignManagers, { frontUserId })[0];
    const isSelectedCMAvailable = isCampaignManagerAvailable(selectedCM);
    if (selectedCM && isSelectedCMAvailable) {
      return selectedCM;
    }
    const nextAvailableCMs = getNextAvailableCampaignManagers(campaignManagers);
    logger.debug("CampaignSidebar:getCampaignManagerToShow", "called", {
      campaignManagers,
      frontUserId,
      selectedCM,
      nextAvailableCMs
    });
    if (nextAvailableCMs && nextAvailableCMs.length == 1) {
      return nextAvailableCMs[0];
    } else if (nextAvailableCMs && nextAvailableCMs.length > 1) {
      return getCMwithMostComments(nextAvailableCMs, comments);
    }
    return selectedCM;
  }

  render() {
    const { isExternal, t } = this.props;
    const snappoint = 290;
    const isFixed = this.props.startY === 0 ? true : !(this.props.heightY < snappoint);

    const style = {
      position: isFixed ? "fixed" : "absolute",
      top: isFixed ? 63 : snappoint
    };

    if (isFixed) {
      style["bottom"] = 0;
      style["overflowY"] = "scroll";
    }

    if (isExternal) {
      style.top = "366px";
      style.right = "40px";
    }

    const styleBtn = classNames({
      conversation__btn: true,
      "conversation__btn--active": this.state.value && this.state.value.length > 0
    });

    const { folderName } = prepareImageFolderName(
      this.props.orgaName || "",
      this.props.companyName || ""
    );

    const campaignManager = this.state.campaignManagerData;
    const campaignMangaerAvailable = isCampaignManagerAvailable(campaignManager);

    return (
      <div className="campaign-read__activity" style={style} onScroll={this.handleScroll}>
        <div className="expert">
          <h2>{t("Available today")}</h2>
          <img src={campaignManager && campaignManager.photo} className="expert__img" alt="" />
          <div className="expert__name">
            <strong>{campaignManager && campaignManager.userName}</strong>
            {campaignMangaerAvailable && (
              <span className="user__state user__state--online">{t("Available")}</span>
            )}
            {!campaignMangaerAvailable && (
              <span className="user__state">{t("Available soon")}</span>
            )}
            <span className="user__position">{campaignManager && campaignManager.role}</span>
          </div>
        </div>
        <div className="conversation">
          <div className="conversation__post">
            <textarea
              onChange={this.onChange.bind(this)}
              onKeyPress={this.handleKeyPress.bind(this)}
              placeholder={t("Feel free to ask us a question ...")}
              value={this.state.value}
            />
            <button className={styleBtn} onClick={this.saveComment.bind(this, campaignManager)}>
              <svg
                className="svg-icon"
                viewBox="0 0 20 20"
                style={{ position: "relative", left: "-5px" }}
              >
                <path d="M17.218,2.268L2.477,8.388C2.13,8.535,2.164,9.05,2.542,9.134L9.33,10.67l1.535,6.787c0.083,0.377,0.602,0.415,0.745,0.065l6.123-14.74C17.866,2.46,17.539,2.134,17.218,2.268 M3.92,8.641l11.772-4.89L9.535,9.909L3.92,8.641z M11.358,16.078l-1.268-5.613l6.157-6.157L11.358,16.078z"></path>
              </svg>
            </button>
          </div>
          <UploadPhotoBtn
            folderName={folderName}
            context={`orgaId=${this.props.orgaId}|campaignId=${this.props.campaignId}|source=comments`}
            showPreview={false}
            label={t("+ Upload file")}
            showLoading={true}
            handlePictureChanged={this.handlePictureChanged.bind(this)}
          />

          <br />
          <br />
          <div className="conversation__feed">
            <div className="comments">{this.renderComments()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CampaignReadSideBar);
